import { createRoot } from 'react-dom/client';
import { init as fullstoryInit } from '@fullstory/browser';
import { datadogRum } from '@datadog/browser-rum';

import { App } from './app';

fullstoryInit({ orgId: '8HR7J', devMode: process.env.NODE_ENV === 'development' });

datadogRum.init({
    applicationId: '5768639c-9735-45cf-8ee2-15807c1b7480',
    clientToken: 'pub2076a7000a540aa9d7986f0d16e23da3',
    site: 'datadoghq.com',
    service: 'enterprise-hub',
    env: window.location.hostname,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackViewsManually: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
});

const appContainer = document.createElement('div');
document.body.appendChild(appContainer);

const root = createRoot(appContainer);
root.render(<App />);
